<app-header></app-header>
<div class="self-description vh-centered-child">
  <app-author-description></app-author-description>
</div>
<div class="project-layout">
  <div class="project-description">
  <app-project-description></app-project-description>
  </div>
  <div class="project-image vh-centered-child">
    <app-project-image></app-project-image>
  </div>
</div>
<div class="career">
  <app-career-journey></app-career-journey>
</div>
<div class="skills">
  <app-skills></app-skills>
</div>
<div class="project-list">
  <app-project-list></app-project-list>
</div>
<app-footer></app-footer>
<router-outlet></router-outlet>